import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import React from "react";
import { createDispatchHook, createSelectorHook, TypedUseSelectorHook } from "react-redux";
import itemsControlReducer from "./itemsControl/mainSlice";

export const ItemsControlContext = React.createContext(null);

const store = configureStore({
    reducer: {
        itemsControl: itemsControlReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;

export type ItemsControlDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const useItemsControlDispatch = createDispatchHook<ItemsControlDispatch>(ItemsControlContext);
export const useItemsControlSelector: TypedUseSelectorHook<RootState> = createSelectorHook(ItemsControlContext);
